import { EOffersForSelectionTypes } from '../../actions/offersForSelection';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const offersForSelectionReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EOffersForSelectionTypes.SetOffersSelectionSucceed:
      return {
        ...state,
        offersForSelection: {
          ...state.offersForSelection,
          canLoadMore: action.payload.canLoadMore || false,
          list: [...state.offersForSelection.list, ...action.payload.list],
          page: action.payload.page || 0,
          totalCount: action.payload.totalCount || 0,
          status: ERequestApiStatus.Succeed,
        },
      };

    case EOffersForSelectionTypes.SetOffersSelectionInitial:
      return {
        ...state,
        offersForSelection: {
          ...state.offersForSelection,
          canLoadMore: true,
          status: ERequestApiStatus.Initial,
          list: [],
          page: 0,
          totalCount: 0,
        },
      };

    case EOffersForSelectionTypes.SetOffersSelectionPending:
      return {
        ...state,
        offersForSelection: {
          ...state.offersForSelection,
          status: ERequestApiStatus.Pending,
        },
      };

    case EOffersForSelectionTypes.SetOffersSelectionFailed:
      return {
        ...state,
        offersForSelection: {
          ...state.offersForSelection,
          status: ERequestApiStatus.Failed,
        },
      };

    default:
      return state;
  }
};
